var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "comment__like",
      class: [
        _vm.isMobile
          ? "comment__like--show-on-mobile"
          : "comment__like--not-for-mobile"
      ],
      attrs: { id: _vm.comment.id }
    },
    [
      _c("div", { staticClass: "comment__like-counter" }, [
        _vm._v("\n        " + _vm._s(_vm.likesCount) + "\n    ")
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "comment__like-btn",
        class: _vm.likeBtnClass,
        on: { click: _vm.like }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }